var SceneSubject = /** @class */ (function () {
    function SceneSubject(scene) {
        this.scene = scene;
        this.onCreate();
    }
    return SceneSubject;
}());
export { SceneSubject };
